(() => {
  const apMakes = new Set('AU BM BY CH CR CT DA DH EU FA FD GW HA HD HL HN HY IS IV JE KA LD LR LX MB MG MT MZ NS OP PE PR PT RA RN SA SK SU SZ TE TY UN VL VW'.split(' '));
  const apCodes = new Set('05 10 11 12 13 14 16 17 18 20 21 23 24 26 27 28 29 2C 2D 2E 2F 30 31 32 33 34 35 36 38 39 3B 3D 3E 3F 3G 3H 3J 3K 3M 3N 40 41 42 43 44 45 47 48 49 4A 4B 4C 4D 4F 4J 4K 4M 4N 4P 4Q 4S 4T 4U 4W 4X 4Y 4Z 50 51 52 53 57 58 59 5A 60 61 62 63 64 65 66 67 68 69 6A 6B 6E 6F 6G 6J 6K 6N 6S 6T 6W 6X 70 71 72 73 74 75 76 77 78 79 7A 7B 7C 7E 7F 7G 7H 7J 7K 7L 7M 7P 7Q 7S 7T 7U 7W 7Y 7Z 80 81 83 84 85 86 87 88 89 8A 8B 8C 8D 8E 8F 90 91 92 93 94 95 98 99 9A 9B 9C 9D 9F 9G 9H 9J 9K 9L 9P 9Q 9S 9T 9U 9W 9X 9Y 9Z AE AF AL AQ AS AT AU AW AX BI BJ CE EA FA FB FC FF HB HD HG J1 J2 J3 J4 J5 J6 J7 J9 JA JB JC JD JE JF JG JH JJ JK JM JN JP JQ K1 K2 K3 KA'.split(' '));
  const simplePart = /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9][A-Za-z0-9./-]{2,63}$/;

  const restore = (value) => {
    const query = String(value ?? '').trim();
    const divider = query.indexOf(' OR tag:');
    if (divider < 0) return query;
    const part = query.slice(0, divider);
    if (!simplePart.test(part)) return query;
    const suffix = query.slice(divider + 8);
    return [part, `"${part}"`, `&quot;${part}&quot;`, `&amp;quot;${part}&amp;quot;`, `&#34;${part}&#34;`, `&#x22;${part}&#x22;`].includes(suffix) ? part : query;
  };

  const isAP = (value) => {
    const query = value.toUpperCase();
    if (!apMakes.has(query.slice(0, 2))) return false;
    if (/^[A-Z]{2}[0-9]{0,4}$/.test(query)) return true;
    const match = /^([A-Z]{2})[0-9]{4}([A-Z0-9]{2})[A-Z0-9]{0,5}(?:-[A-Z0-9]{0,3})?$/.exec(query);
    return Boolean(match && apCodes.has(match[2]));
  };

  const expand = (value) => {
    const query = restore(value);
    if (!simplePart.test(query) || isAP(query)) return query;
    return `${query} OR tag:${query}`;
  };

  window.APPartSearch = Object.freeze({ expand, restore });

  document.addEventListener('formdata', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form.search') || form.method.toLowerCase() !== 'get') return;
    const input = form.querySelector('input[type="search"][name="q"]');
    const filter = form.querySelector('select[data-type]');
    if (!input || (filter && filter.value.trim())) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/search\/?$/.test(action.pathname)) return;
    event.formData.set('q', expand(input.value));
  }, true);
})();
